export default __webpack_public_path__ + "static/9088ourmission-a3bc445448f0e5b96c32b57d405d06b3.jpg";